<div class="associations-container dark-mode">
    <div class="page-header mt-5">
        <div class="d-flex">
            <mat-icon class="back-button" [routerLink]="'/office/new-certification'">chevron_left</mat-icon>
            <h1 class="page-title">Detail Certification</h1>
        </div>
        <div class="breadcrumb">
            <span class="breadcrumb-item">Dashboard</span>
            <span class="breadcrumb-separator mx-2">/</span>
            <span class="breadcrumb-item" [routerLink]="'/office/new-certification'">Certifications</span>
            <span class="breadcrumb-separator mx-2">/</span>
            <span class="breadcrumb-current">{{ certification?.certificationTitle }}</span>
        </div>
    </div>

    <hr class="mb-4" />

    <ul class="nav nav-tabs" id="myTab" role="tablist">
        <li class="nav-item" role="presentation">
            <button class="nav-link  {{activeTab == 'overview' ? 'active':''}}" id="overview-tab" data-bs-toggle="tab" data-bs-target="#overview"
                    type="button" role="tab">Overview</button>
        </li>
        <li class="nav-item" role="presentation">
            <button
                    class="nav-link  {{activeTab == 'detail' ? 'active':''}}"
                    id="certification-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#certification"
                    type="button"
                    role="tab">Certification Information</button>
        </li>
        <li class="nav-item" role="presentation">
            <button
                    class="nav-link  {{activeTab == 'domains' ? 'active':''}}"
                    id="domain-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#domain"
                    type="button" role="tab">Domains</button>
        </li>
        <li class="nav-item" role="presentation">
            <button
                    class="nav-link  {{activeTab == 'objectives' ? 'active':''}}"
                    id="objective-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#objective"
                    type="button" role="tab">Objectives</button>
        </li>
    </ul>

    <div class="tab-content" id="myTabContent">
        <div class="tab-pane fade {{activeTab == 'overview' ? 'show active':''}} py-3" id="overview" role="tabpanel">
            <app-new-certification-detail-dashboard *ngIf="certification"
                    [certification]="certification"
                    [associations]="associations"
                    [attendanceTypes]="attendanceTypes"
                    [activities]="activities"
                    [restricted]="restricted"
            ></app-new-certification-detail-dashboard>
        </div>
        <div class="tab-pane fade {{activeTab == 'detail' ? 'show active':''}} py-3" id="certification" role="tabpanel">
            <div class="row">
                <div class="col-12">
                    <h4 class="text-color-black-normal-50 label-text">Certification Title</h4>
                    <div class="label-text">{{certification?.certificationTitle}}</div>
                </div>
            </div>

            <div class="row mt-4">
                <div class="col-12">
                    <h4 class="text-color-black-normal-50 label-text">Association</h4>
                    <div class="label-text">{{certification?.associationName}}</div>
                </div>
            </div>

            <div class="row mt-4">
                <div class="col-12">
                    <h4 class="text-color-black-normal-50 label-text">CEU Required</h4>
                    <div class="label-text">{{certification?.ceuRequired}}</div>
                </div>
            </div>

            <div class="row mt-4">
                <div class="col-12">
                    <h4 class="text-color-black-normal-50 label-text">Duration</h4>
                    <div class="label-text">{{certification?.duration}} Year(s)</div>
                </div>
            </div>

            <div class="row mt-4">
                <div class="col-12">
                    <h4 class="text-color-black-normal-50 label-text">Duration in Months</h4>
                    <div class="label-text">{{certification?.durationInMonths}} Month(s)</div>
                </div>
            </div>

            <div class="row mt-4">
                <div class="col-12">
                    <h4 class="text-color-black-normal-50 label-text">Price</h4>
                    <div class="label-text">$ {{certification?.price}}</div>
                </div>
            </div>

            <div class="row mt-4">
                <div class="col-12">
                    <h4 class="text-color-black-normal-50 label-text">Attendance Types</h4>
                    <div class="label-text">{{mergeAttendanceTypes(certification?.attendanceTypes)}}</div>
                </div>
            </div>



            <div class="row mt-4">
                <div class="col-12">
                    <h4 class="text-color-black-normal-50 label-text">Certification Activities</h4>

                    <div class="table-responsive-dark list-wrapper-bordered-dark">
                        <table class="table table-striped table-hover table-bordered ">
                            <thead>
                            <tr>
                                <th class="text-nowrap">Activity Type</th>
                            </tr>
                            </thead>
                            <tbody>
                            <ng-container *ngIf="activities?.length > 0">
                                <tr *ngFor="let activity of activities">
                                    <td class="text-start">
                                       {{activity.activityType}}
                                    </td>
                                </tr>
                            </ng-container>

                            <tr *ngIf="activities.length == 0">
                                <td class="text-center">
                                    <span>No Record</span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div class="row mt-4">
                <div class="col-12">
                    <button class="edit-button" (click)="goEdit(certification?.id)" mat-raised-button >
                        <mat-icon>edit</mat-icon>
                        Edit
                    </button>
                </div>
            </div>
        </div>
        <div class="tab-pane fade {{activeTab == 'domains' ? 'show active':''}} py-3" id="domain" role="tabpanel">
            <app-new-certification-domain-list *ngIf="certification"
                    [certification]="certification"
                    [providers]="associations"
                    [attendanceTypes]="attendanceTypes"
            ></app-new-certification-domain-list>
        </div>
        <div class="tab-pane fade {{activeTab == 'objectives' ? 'show active':''}} py-3" id="objective" role="tabpanel">
            <app-new-certification-objective-list *ngIf="certification"
                  [certification]="certification"
                  [providers]="associations"
                  [attendanceTypes]="attendanceTypes"
            ></app-new-certification-objective-list>
        </div>
    </div>


</div>

